import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function MandatoryBadge({ label, className }) {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        'flex h-6 items-center justify-center rounded-full border border-[#9D174D1A] bg-lightRed px-2.5',
        className
      )}
    >
      <span className='text-xs font-semibold uppercase text-darkRed'>
        {label ?? t('discover.evaluation.mandatory_criteria_label')}
      </span>
    </div>
  )
}

MandatoryBadge.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string
}
